export const getNow = () => new Date();

export const getDeltaFromNow = (seconds: number): Date => {
  return (new Date(getNow().getTime() - (seconds * 1000)));
};
